// "Email me when someone @mentions me" switch, on the Notifications page.
//
// Opt-out by design: the field is absent for everyone until they touch it, and
// mentionNotify treats anything but an explicit false as yes. That way turning
// the feature on for the team does not depend on anyone finding this screen.
import { useState } from "react";
import { AtSign } from "lucide-react";
import { toast } from "react-toastify";
import { updateUserProfile } from "../../utils/firebasefunctions";

export default function MentionEmailToggle({ user, onChange }) {
  const [on, setOn] = useState(user?.emailOnMention !== false);
  const [saving, setSaving] = useState(false);

  const flip = async () => {
    if (!user?.id || saving) return;
    const next = !on;
    // Move the switch first. Waiting on Firestore makes it feel broken, and
    // the catch below puts it back if the write does not land.
    setOn(next);
    setSaving(true);
    try {
      const ok = await updateUserProfile(user.id, { emailOnMention: next });
      if (ok === false) throw new Error("write rejected");
      onChange?.(next);
    } catch (err) {
      console.error("Mention email preference save failed:", err);
      setOn(!next);
      toast.error("Couldn't save that. Check your connection.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex items-center justify-between gap-4 bg-white border border-slate-200 rounded-xl px-4 py-3">
      <div className="flex items-start gap-3 min-w-0">
        <div className="bg-[#EEF2FF] text-[#1E293B] size-8 rounded-full flex items-center justify-center shrink-0">
          <AtSign size={16} />
        </div>
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-900">
            Email me when I'm tagged
          </p>
          <p className="text-xs text-slate-500">
            You always get the bell and a phone alert. This adds an email.
          </p>
        </div>
      </div>
      <button
        type="button"
        role="switch"
        aria-checked={on}
        aria-label="Email me when I'm tagged"
        onClick={flip}
        className={`relative w-11 h-6 rounded-full shrink-0 transition ${
          on ? "bg-[#218FDA]" : "bg-slate-300"
        }`}
      >
        <span
          className={`absolute top-0.5 size-5 bg-white rounded-full shadow transition-all ${
            on ? "left-[22px]" : "left-0.5"
          }`}
        />
      </button>
    </div>
  );
}
